export const defaultColDef = {
  flex: 1,
  minWidth: 50,
  sortable: true,
  suppressMovable: true,
  resizable: true,
  menuTabs: [],
  // enableCellChangeFlash: true,
}
